export function formatNumberWithComma(number: number) {
	return new Intl.NumberFormat().format(number);
}
